// Canonical activity names the submission phase-dispatch (apps/functions
// submitQuestionnaire) and the editor publish-time validation (HUB-2167) key
// off. The seed DSL declares activities under exactly these names.
export const FIXED_ACTIVITY_NAMES = {
  prescreener: 'prescreener',
  icf: 'icf',
} as const;

export type FixedActivityName =
  (typeof FIXED_ACTIVITY_NAMES)[keyof typeof FIXED_ACTIVITY_NAMES];

// Protocol order: the prescreener precedes the ICF.
export const FIXED_ACTIVITY_NAME_LIST = [
  FIXED_ACTIVITY_NAMES.prescreener,
  FIXED_ACTIVITY_NAMES.icf,
] as const satisfies readonly FixedActivityName[];

export const isFixedActivityName = (name: string): name is FixedActivityName =>
  (FIXED_ACTIVITY_NAME_LIST as readonly string[]).includes(name);
